import { Box, Typography, Button, Stack, Chip } from '@mui/material';
import { keyframes } from '@mui/system';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const pulse = keyframes`
  0%,100% { transform: scale(1); opacity: .7; }
  50% { transform: scale(1.15); opacity: 1; }
`;
const floatBall = keyframes`
  0%,100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-30px) rotate(180deg); }
`;
const slideUp = keyframes`
  from { opacity:0; transform:translateY(40px); }
  to   { opacity:1; transform:translateY(0); }
`;

const Hero = () => (
  <Box sx={{
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    position: 'relative', overflow: 'hidden',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 50%, #f0fdf4 100%)',
    textAlign: 'center', px: 3,
  }}>
    {/* Animated background orbs */}
    {[...Array(3)].map((_, i) => (
      <Box key={i} sx={{
        position: 'absolute', borderRadius: '50%',
        width: [300, 500, 200][i], height: [300, 500, 200][i],
        top: ['10%', '50%', '80%'][i], left: ['5%', '60%', '20%'][i],
        background: [
          'rgba(34,197,94,.10)',
          'rgba(22,163,74,.07)',
          'rgba(34,197,94,.08)',
        ][i],
        animation: `${pulse} ${[4, 6, 3.5][i]}s ease-in-out infinite`,
        animationDelay: `${i * 0.8}s`,
        filter: 'blur(40px)',
      }} />
    ))}

    {/* Floating ball */}
    <Box sx={{
      position: 'absolute', top: '15%', right: '8%',
      animation: `${floatBall} 5s ease-in-out infinite`,
    }}>
      <SportsSoccerIcon sx={{ fontSize: 80, color: 'rgba(34,197,94,.25)' }} />
    </Box>

    <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 800 }}>
      <Chip label="⚡ Plateforme N°1 en Afrique" sx={{
        mb: 3,
        bgcolor: 'rgba(34,197,94,.10)',
        color: '#16a34a',
        border: '1px solid rgba(34,197,94,.35)',
        fontWeight: 700,
        animation: `${slideUp} .8s ease forwards`,
      }} />

      <Typography variant="h1" sx={{
        fontSize: { xs: '2.8rem', md: '5rem' }, fontWeight: 900, lineHeight: 1.1,
        color: '#0f172a', mb: 2,
        animation: `${slideUp} .9s ease forwards`,
      }}>
        Découvrez les{' '}
        <Box component="span" sx={{
          background: 'linear-gradient(90deg, #16a34a, #22c55e, #4ade80)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>
          Talents
        </Box>{' '}de Demain
      </Typography>

      <Typography variant="h5" sx={{
        color: '#64748b', mb: 5, fontWeight: 300,
        animation: `${slideUp} 1s ease forwards`,
      }}>
        Suivi des talents · Gestion de tournois · Statistiques avancées
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center"
        sx={{ animation: `${slideUp} 1.1s ease forwards` }}>
        <Button variant="contained" size="large" startIcon={<EmojiEventsIcon />} sx={{
          background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
          color: '#fff', fontWeight: 800, px: 4, py: 1.8,
          borderRadius: 3, fontSize: '1rem',
          boxShadow: '0 4px 16px rgba(34,197,94,.3)',
          '&:hover': {
            background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
            transform: 'translateY(-3px)',
            boxShadow: '0 12px 30px rgba(34,197,94,.35)',
          },
          transition: 'all .3s',
        }}>
          Commencer Gratuitement
        </Button>
        <Button variant="outlined" size="large" sx={{
          borderColor: 'rgba(34,197,94,.4)', borderWidth: '1.5px',
          color: '#16a34a', px: 4, py: 1.8,
          borderRadius: 3, fontSize: '1rem',
          '&:hover': {
            borderColor: '#22c55e', borderWidth: '1.5px',
            bgcolor: 'rgba(34,197,94,.06)',
            transform: 'translateY(-2px)',
          },
          transition: 'all .3s',
        }}>
          Voir une Démo
        </Button>
      </Stack>
    </Box>
  </Box>
);

export default Hero;